import React, {
    useEffect,
    useRef,
    useState
} from 'react'
import {
    Slider,
    Tooltip
} from 'antd';
import './audio.less'
import {
    toNumber
} from 'lodash';
import ga from '@Lib/ga'


function jsBridge(callback) {
	if (window.WebViewJavascriptBridge) {
		return callback(WebViewJavascriptBridge);
   }else{
	   document.addEventListener('WebViewJavascriptBridgeReady', function() {
		   callback(WebViewJavascriptBridge)
	   },false);
   if (window.WVJBCallbacks) {
		return window.WVJBCallbacks.push(callback);
   }
   window.WVJBCallbacks = [callback];
   var WVJBIframe = document.createElement('iframe');
   WVJBIframe.style.display = 'none';
   WVJBIframe.src = 'https://__bridge_loaded__';
   document.documentElement.appendChild(WVJBIframe);
   setTimeout(function() { document.documentElement.removeChild(WVJBIframe) }, 0)}
}



interface IProps {
    voiceData: {
        url: string; // 音频地址
        questionnairePosition?: string; // 暂停在什么地方要问卷调查，0.5则为50%
        duration?: string; // 音频全部时长
        autoplay?: boolean; // 自动播放
    }
    text?: string; // 播放文本
    color?: string; // 主题色
    preload?: 'none' | 'metadata' | 'auto'; // 音频预加载方式
    children?: string | HTMLElement; // 插槽
    [key: string]: any;
}

interface BridgeData {
    'shouldShowReport': '1' | '0',
    'totalDuration': string,
    "playDuration": string,
    'isPlaying': '1' | '0',
}


const Audio:React.FC<IProps> = (props:IProps) => {
    const {
        voiceData: {
            autoplay = false,
            questionnairePosition = '0.5',
            url: src,
        },
        children,
        preload = 'auto',
    } = props;

    const [currentTime, setCurrentTime] = useState<number>(0) // 当前播放时间
    const [duration, setDuration] = useState<number>(0) // 音频全部时长
    const [popTime, setPopTime] = useState<number>(0) // 音频全部时长
    const [play, setPlay] = useState<boolean>(false) // 音频开关
    const [disabled, setDisabled] = useState<boolean>(true) // 进度条是否可拖动，防止音频在不可使用时用户拖动进度条
    const [process, setProcess] = useState<number>(0) // 音频进度百分比
    const [showPop, setShowPop] = useState<boolean>(false) // 气泡展示
    const [showAudioToolTip, setShowAudioToolTip] = useState<boolean>(false) // 第一次气泡展示


    const audio = useRef<HTMLAudioElement>(null)
    const handleBridgeData = useRef<BridgeData>()

    useEffect(() => {
        const pr = Math.floor((currentTime / duration) * 100)
        if (!isNaN(pr)) {
            setProcess(pr)
        }
    }, [currentTime, duration])

    useEffect(() => {
        if (!play && !disabled) {
            const shouldShowReport = process <= toNumber(questionnairePosition) * 100
            // 暂停且进度小于50%，主动触发调研问卷，
            jsBridge(function(bridge: any) {
                bridge.callHandler('articleVoiceDidPause',
                    {
                        'shouldShowReport': shouldShowReport ? '1' : '0',
                        'totalDuration': duration.toString(),
                        "playDuration": currentTime.toString()
                    },
                    function responseCallback(_responseData) {
                        // responseData
                    }
                )
            })
        }
    }, [play])


    useEffect(() => {
        const judgeIos = !/Chrome/i.test(navigator.userAgent) && !/Android/i.test(navigator.userAgent)
        if (judgeIos){
            audio.current?.load();
        }

        ga(['文章', '文字轉語音', '曝光次數']);

        const locShowAudioToolTip = localStorage.getItem('showAudioToolTip') === null;

        localStorage.setItem('showAudioToolTip', '1');

        if (locShowAudioToolTip) {
            setShowAudioToolTip(true)
            setTimeout(() => {
                setShowAudioToolTip(false)
            }, 5000)
        }

        // 未播放，直接退出=0
        // 播放過 && 且小於50%，退出 = 1
        jsBridge(function(bridge: any) {
            bridge.registerHandler('articleBackVoiceReportNeedShow', function(_data: any, responseCallback: Function) {
                responseCallback(handleBridgeData.current)
            })
        })

    }, [])

    useEffect(() => {

        const shouldShowReport = currentTime !== 0 && process <= toNumber(questionnairePosition) * 100
        handleBridgeData.current = {
            'shouldShowReport': !!shouldShowReport ? '1' : '0',
            'totalDuration': duration.toString(),
            "playDuration": currentTime.toString(),
            'isPlaying': play ? '1' : '0'
        }


    }, [process, duration, play])

    const onCanPlay = () => {
        setDisabled(false)
        setDuration(audio?.current?.duration as number)
    };

    const onChange = (value:any): void => {
        const time = Math.floor((value * duration) / 100);

        let settoShowPop;

        setPopTime(time);

        setCurrentTime(time);
        audio.current.currentTime = time

        if (showPop) {
            clearTimeout(settoShowPop)
            return;
        }
        setShowPop(true);

        settoShowPop =  setTimeout(() => {
            setShowPop(false);
        }, 1000);
    }

    const onPlayButton = ():void => {
        if (disabled) return;

        setPlay(!play)

        if (play) {
            audio?.current?.pause()
            // 触发暂停埋点
            ga(['文章', '文字轉語音', '暫停']);
        } else {
            audio?.current?.play()
            // 触发播放埋点
            ga(['文章', '文字轉語音', '播放']);
        }
    }

    const durationHandle = (pr: number): string => {
        const trans = (para: number):string => {
            if (isNaN(para)) return '00'

            if(para < 10) return '0' + para

            return para.toString()
        }

        const minute:string = trans(Math.floor(pr / 60))

        const seconds:string = trans(Math.floor(pr % 60))

        return `${ minute }:${ seconds }`
    }

    const onTimeUpdate = () => {
        setCurrentTime(audio.current.currentTime);
    }

    const onEnded = () => {
        setPlay(false)
        setCurrentTime(0);
        audio.current.currentTime = 0;
    }

    return (
        <div>
            <div className={'Audio_base_style'}>
                <div className={'text'} />
                <Tooltip
                    visible={showAudioToolTip}
                    placement='bottom'
                    overlayClassName={ 'audioToolTip' }
                    title='點擊播放按鈕可文字轉語音播放喔~'
                    arrowPointAtCenter={false}
                >
                    <div
                        onClick={onPlayButton}
                        className={play ? 'pauseImg': 'playImg'}
                    />
                </Tooltip>

                    <div className={'slider_container'}>
                        <span className={ 'time' }>
                            { durationHandle(currentTime) }
                        </span>

                        <Tooltip
                            visible={showPop}
                            placement='topLeft'
                            overlayClassName={ 'popTime' }
                            title={ durationHandle(popTime) }
                            arrowPointAtCenter={false}
                            getPopupContainer={() => document.querySelector('.ant-slider-handle') as HTMLElement}
                        >
                            <Slider
                                min={0}
                                max={100}
                                onChange={onChange}
                                value={process}
                                disabled={disabled}
                                className={ 'process' }
                                tooltipVisible={false}
                                maximumTrackTintColor='#d8d8d8'
                                minimumTrackTintColor='#3264ff'
                            />
                        </Tooltip>

                        <span className={ 'time' }>
                            { durationHandle(duration) }
                        </span>
                    </div>
                </div>
            <audio
                ref={audio}
                autoPlay={autoplay}
                src={src}
                preload={preload}
                onTimeUpdate={onTimeUpdate}
                onCanPlay={onCanPlay}
                onEnded={onEnded}
            />
            { children && children }
        </div>
    )
}

export default Audio
